// src/components/PurchaseFlow/Steps/ConfirmationViews/DefaultSuccessView.js
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faCheck, 
  faFileContract,
  faReceipt,
  faListCheck,
  faFlagCheckered,
  faClock,
  faInfoCircle,
  faHome,
  faFileAlt,
  faFileSignature
} from '@fortawesome/free-solid-svg-icons';

const DefaultSuccessView = ({ 
  contracts,
  payment,
  customerMyAccount,
  contractDownloaded,
  onPrintContract,
  onPrintReceipt,
  onShareMyAccount,
  onViewDetail
}) => {
  return (
    <div className="">
      {/* Header con ícono de éxito */}
      <div className="text-center my-4 border-bottom pb-4">
        <div className="stepper-success-icon">
          <FontAwesomeIcon icon={faCheck} />
        </div>
        <h2 className="text-success">¡Venta confirmada!</h2>
        <p>La venta quedó registrada correctamente.</p>
        <h6>
          <span className="badge bg-warning rounded-pill d-inline-flex align-items-center gap-2 p-3" style={{color: '#212529'}}>
            <FontAwesomeIcon icon={faFileSignature} />
            Estado: Pendiente de Firma
          </span>
        </h6>
        <p className="text-muted mt-2">
          El contrato debe imprimirse y firmarse antes de entregar el producto.
        </p>
      </div>

      {/* Botones de acción principales */}
      <div className="action-buttons">
        <div className="row g-2 justify-content-center">
          <div className="col-md-4">
            <button 
              className="btn btn-primary w-100"
              title='Ver o imprimir el contrato de adhesión'
              onClick={() => onPrintContract(contracts[0].url)}
            >
              <FontAwesomeIcon icon={faFileContract} className="me-2" />
              Imprimir Contrato
            </button>
          </div>
          {payment && payment.receipt_url && (
            <div className="col-md-4">
              <button
                className="btn btn-outline-primary w-100"
                onClick={() => onPrintReceipt(payment.receipt_url)}
                title='Ver o imprimir el comprobante del pago inicial'
              >
                <FontAwesomeIcon icon={faReceipt} className="me-2" />
                Imprimir Comprobante
              </button>
            </div>
          )}
        </div>
      </div>

      {/* Instrucciones */}
      <div className="row justify-content-center">
        <div className="steps-guide col-md-8">
          <h6 className="steps-guide-title">
            <FontAwesomeIcon icon={faListCheck} className="me-2" />
            Próximos pasos:
          </h6>
          
          <div className="steps-list">
            <div className="step-item">
              <div className="step-marker">1</div>
              <div className="step-content">
                Imprimí el contrato y entregalo al cliente para que lo firme.
              </div>
            </div>
            
            <div className="step-item">
              <div className="step-marker">2</div>
              <div className="step-content">
                Una vez firmado, entrega el producto.
              </div>
            </div>

            {customerMyAccount && (
              <div className="step-item">
                <div className="step-marker">3</div>
                <div className="step-content">
                  Compartí con el cliente el acceso a <button className="btn btn-link text-primary p-0" onClick={onShareMyAccount}>Mi Cuenta</button>
                </div>
              </div>
            )}
          </div>

          <div className="steps-divider">
            <FontAwesomeIcon icon={faFlagCheckered} className="me-2" />
            FIN DEL PROCESO CON EL CLIENTE
          </div>

          <div className="steps-list">
            <div className="step-item">
              <div className="step-marker">
                <FontAwesomeIcon icon={faClock} />
              </div>
              <div className="step-content">
                Después, subí el contrato firmado al sistema.
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Recordatorio */}
      <div className="alert alert-warning d-flex align-items-center">
        <FontAwesomeIcon icon={faInfoCircle} className="fs-4 me-2" />
        <div>
          <strong>Importante:</strong> subí el contrato firmado desde la sección de documentos.
        </div>
      </div>

      {contractDownloaded && (
        <div className="navigation-buttons border-top">
          <button 
            className="btn btn-light-secondary"
            onClick={() => window.location.href = '/'}
          >
            <FontAwesomeIcon icon={faHome} className="me-2" />
            Volvé al inicio
          </button>
          <button 
            className="btn btn-primary"
            onClick={onViewDetail}
          >
            <FontAwesomeIcon icon={faFileAlt} className="me-2" />
            Ver Detalle de Venta
          </button>
        </div>
      )}
    </div>
  );
};

export default DefaultSuccessView;
